var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showSnackbar
        ? _c("Snackbar", {
            attrs: {
              snackbarColor: _vm.snackbarColor,
              snackbarMessage: _vm.snackbarMessage
            },
            on: {
              close: function($event) {
                return _vm.closeSnackbar()
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-layout",
        { staticClass: "notesLayout" },
        [
          _c(
            "v-sheet",
            {
              staticClass: "notes",
              attrs: {
                color: "#fcfaf2",
                elevation: "15",
                height: "auto",
                width: "300px"
              }
            },
            [
              _c(
                "v-layout",
                {
                  staticClass: "notes_title",
                  attrs: { "overflow-hidden": "" }
                },
                [
                  _c(
                    "b",
                    { attrs: { title: _vm.notesInfo.tenant + " - Notes" } },
                    [_vm._v(_vm._s(_vm.notesInfo.tenant) + " - Notes")]
                  ),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-icon",
                    {
                      attrs: {
                        color: _vm.showPencil ? "" : "green",
                        title: _vm.showPencil ? "Edit" : "Save"
                      },
                      on: {
                        click: function($event) {
                          _vm.showPencil ? "" : _vm.updateNotes()
                          _vm.showPencil = !_vm.showPencil
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.showPencil ? "create" : "done"))]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-icon",
                    {
                      attrs: {
                        color: "red",
                        title: !_vm.showPencil ? "Cancel" : "Close"
                      },
                      on: {
                        click: function($event) {
                          !_vm.showPencil
                            ? _vm.cancelEdit()
                            : _vm.$emit("close")
                        }
                      }
                    },
                    [_vm._v("close")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-layout",
                { staticClass: "lastEdit", attrs: { "overflow-hidden": "" } },
                [
                  _vm._v(
                    "\n                Last Edit by " +
                      _vm._s(_vm.notesInfo.username) +
                      " at " +
                      _vm._s(_vm.notesInfo["timeStamp"].toLocaleTimeString()) +
                      " on " +
                      _vm._s(_vm.notesInfo["timeStamp"].toLocaleDateString()) +
                      "\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c("v-textarea", {
                attrs: {
                  "background-color": _vm.showPencil ? "#fcfaf2" : "#faebd7",
                  readonly: _vm.showPencil,
                  "no-resize": "",
                  rows: "22"
                },
                model: {
                  value: _vm.notes,
                  callback: function($$v) {
                    _vm.notes = $$v
                  },
                  expression: "notes"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }